import { useCallback, useState } from 'react';
import { VIPData } from '../components/VIPForm';

export type FieldMetadata = {
  error: boolean;
};

const useFieldMetadata = (initial: VIPData) => {
  const [meta, setMeta] = useState<Record<keyof VIPData, FieldMetadata>>(
    Object.keys(initial).reduce(
      (acc, key) => {
        acc[key as keyof VIPData] = { error: false };
        return acc;
      },
      {} as Record<keyof VIPData, FieldMetadata>,
    ),
  );

  return { meta, setMeta };
};

export const useVIPFormState = (initial: VIPData) => {
  const [state, setState] = useState(initial);
  const { meta, setMeta } = useFieldMetadata(initial);

  const setValue = useCallback(<K extends keyof VIPData>(key: K, value: VIPData[K]) => {
    setState(oldState => ({
      ...oldState,
      [key]: value,
    }));
  }, []);

  const setErrorFlag = useCallback(
    <K extends keyof typeof meta>(key: K, error: boolean) => {
      setMeta(oldMeta => ({
        ...oldMeta,
        [key]: {
          ...oldMeta[key],
          error,
        },
      }));
    },
    [setMeta],
  );

  return { state, setValue, meta, setErrorFlag };
};
